(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-head"] && !Shopify.designMode) return;
  try {
    const selector = 'a[href*="//calendly.com/neighbor-showroom"]';

  document.addEventListener('DOMContentLoaded', () => {
    const nodes = document.querySelectorAll(selector);

    if (!nodes.length) return;

    nodes.forEach((node) => {
      node.setAttribute('target', '_blank');
      node.addEventListener('click', (event) => {
        if (Calendly) {
          event.preventDefault();
          Calendly.initPopupWidget({ url: node.href });
        }
      });
    });
  });

  // Forward any search-params to any link that contains `/pages/trade-program-form` as the pathname.
  const currentParams = new URLSearchParams(window.location.search);

  if (currentParams.toString()) {
    function forwardParams(link) {
      try {
        const url = new URL(link.href);
        if (!url.pathname.includes('/pages/trade-program-form')) return;
        currentParams.forEach((value, key) => {
          if (!url.searchParams.has(key)) url.searchParams.set(key, value);
        });
        link.href = url.toString();
      } catch (_) {}
    }

    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('a[href]').forEach(forwardParams);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
